import {ApplicationRoute, LOCALIZED_ROUTE_TOKEN} from '../../craft/utils/application.route'

export const ADMIN_ROUTES = {
  ADMIN: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin`), // hardcoded in app-routing user-default-route for tree shaking routes
  ADMIN_JOBS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/jobs`),
  ADMIN_JOBS_ALL: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/jobs/all`, 'jobs/all'),
  ADMIN_JOBS_BOOKMARKED: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/jobs/bookmarked`, 'jobs/bookmarked'),
  ADMIN_JOB: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/jobs/:id`, 'jobs/:id'),
  ADMIN_EDIT_JOB_CONTACT: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/jobs/:id/contact`, 'jobs/:id/contact'),
  ADMIN_EDIT_JOB_BILLING_CONTACT: new ApplicationRoute(
    `/${LOCALIZED_ROUTE_TOKEN}/admin/jobs/:id/billingcontact`,
    'jobs/:id/billingcontact',
  ),
  ADMIN_JOB_ASSIGN_PROS: new ApplicationRoute(
    `/${LOCALIZED_ROUTE_TOKEN}/admin/jobs/:id/assign-pros`,
    'jobs/:id/assign-pros',
  ),
  ADMIN_JOB_ASSIGN_AGENT: new ApplicationRoute(
    `/${LOCALIZED_ROUTE_TOKEN}/admin/jobs/:id/assign-agent`,
    'jobs/:id/assign-agent',
  ),
  ADMIN_START_DAMAGE_JOB: new ApplicationRoute(
    `/${LOCALIZED_ROUTE_TOKEN}/admin/jobs/start/damage`,
    'jobs/start/damage',
  ),
  ADMIN_PROS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/pros`),
  ADMIN_PRO: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/pros/:id`, 'pros/:id'),
  ADMIN_PRO_OVERVIEW: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/pros/:id/overview`, 'overview'),
  ADMIN_PRO_COMPETENCES: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/pros/:id/competences`, 'competences'),
  ADMIN_PRO_JOBS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/pros/:id/jobs`, 'jobs'),
  ADMIN_PRO_PAYMENT: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/pros/:id/payment`, 'payment'),
  ADMIN_PRO_SETTINGS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/pros/:id/settings`, 'settings'),
  ADMIN_EDIT_PRO: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/pros/:id/edit/:part`, 'pros/:id/edit/:part'),
  ADMIN_AGENCIES: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/agencies`),
  ADMIN_AGENCY: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/agencies/:id`, 'agencies/:id'),
  ADMIN_AGENCY_AGENT_LIST: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/agencies/:id/agents`, 'agents'),
  ADMIN_AGENCY_REQUEST_FLOW_LIST: new ApplicationRoute(
    `/${LOCALIZED_ROUTE_TOKEN}/admin/agencies/:id/request-flow`,
    'request-flow',
  ),
  ADMIN_OFFERINGS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/offerings`),
  ADMIN_OFFERINGS_DETAILS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/offerings/:id`, 'offerings/:id'),
  ADMIN_SERVICES: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/services`),
  ADMIN_SEARCH: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/search`),
  ADMIN_SEARCH_PHONE: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/search/phone`, 'phone'),
  ADMIN_METRICS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/dashboard/metrics`, 'dashboard/metrics'),
  ADMIN_METRICS_JOB_ACQUISITION_OVERVIEW: new ApplicationRoute(
    `/${LOCALIZED_ROUTE_TOKEN}/admin/dashboard/jobs-acquisition-overview`,
    'dashboard/jobs-acquisition-overview',
  ),
  ADMIN_INVOICES: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/invoices`),
  ADMIN_USERS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/users`),
  ADMIN_USERS_AGENTS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/users/agents`, 'agents'),
  ADMIN_USERS_PROS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/users/pros`, 'pros'),
  ADMIN_USERS_CLIENTS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/users/clients`, 'clients'),
  ADMIN_CREATE_USER: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/users/create`, 'users/create'),
  ADMIN_ACCOUNTING: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/accounting`),
  ADMIN_MANUAL_ENTRIES: new ApplicationRoute(
    `/${LOCALIZED_ROUTE_TOKEN}/admin/accounting/manual-entries`,
    'manual-entries',
  ),
  ADMIN_MANUAL_ENTRIES_CREATE: new ApplicationRoute(
    `/${LOCALIZED_ROUTE_TOKEN}/admin/accounting/manual-entries/create`,
    'create',
  ),
  ADMIN_PAYBACKS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/admin/paybacks`),
  ADMIN_PAYBACK_DETAIL: new ApplicationRoute(`${LOCALIZED_ROUTE_TOKEN}/admin/paybacks/:id`, 'paybacks/:id'),
}
